import { render, staticRenderFns } from "./contactListEditContacts.vue?vue&type=template&id=06ef6aa9&"
import script from "./contactListEditContacts.vue?vue&type=script&lang=ts&"
export * from "./contactListEditContacts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports